import axios from 'axios'
// create an axios instance
const service = axios.create({
  baseURL: '/api', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000, // request timeout
  headers: {
    'Content-type': 'application/json'
  }
})

// request interceptor
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(

  response => {
    const res = response.data
    // if (res.code !== 0) {
    //   Message({
    //     message: res.message || 'Error',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
      return res
    // }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default function request(method, url, data) {
  method = method.toLocaleLowerCase()
  if (method === 'post') {
    console.log(url)
    return service.post(url, data)
  } else if (method === 'get') {
    return service.get(url, {
      params: data
    })
  } else if (method === 'delete') {
    return service.delete(url, {
      params: data
    })
  }
}



//////////////////
// WEBPACK FOOTER
// ./utils/request.js
// module id = null
// module chunks = 